import { Component,  Input, EventEmitter, Output } from '@angular/core';
import { PhotoComponent } from '../photo';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'person-card',
    template: `
<div class="person-card">
  <photo [size]="size" *ngIf="!hidePhoto" [data]="{title:cardTitle, photoURL:photoUrl}"></photo>
  <div class="titles">
    <div class="title" (click)="select.emit()" [ngStyle]="{'font-weight': bold ? 'bold' : 'normal'}" [ngClass]="{selectable: !disableSelect}">{{ cardTitle }}</div>
    <div class="subtitle" *ngIf="subtitle">{{ subtitle }}</div>
    <div class="greyTitle" *ngIf="greyTitle">{{ greyTitle }}</div>
  </div>
  <ng-content></ng-content>
</div>
`,
    styleUrls: ['./person-card.scss'],
    standalone: true,
    imports: [PhotoComponent, CommonModule],
})

export class PersonCardComponent {
  @Input() cardTitle = '' // The name
  @Input() photoUrl
  @Input() bold = false
  @Input() disableSelect = false
  @Input() size = 24
  @Input() hidePhoto = false
  @Input() subtitle // normal text below the name
  @Input() greyTitle // grey text below the name
  @Output() select: EventEmitter<void> = new EventEmitter();
}
